<template>
  <input type="hidden" name="_token" :value="csrf_token" ref="csrf_token" />
</template>

<script>
import csrfTokenService from "../../api/csrfToken";

export default {
  data: () => {
    return {
      csrf_token: "",
    };
  },

  props: ["value"],

  created: function () {
    this.requestCSRFToken();
  },

  watch: {
    value: {
      handler() {
        this.requestCSRFToken();
      },
    },
  },

  methods: {
    requestCSRFToken: function () {
      csrfTokenService.API.Objects.get_token()
        .then((res) => {
          this.csrf_token = res.data.csrf_token;
          this.$emit("loaded", this.csrf_token);
        })
        .catch((err) => {
          this.loading = false;
          this.$store.dispatch("error", `Erro ${err.message} ao atualizar`);
        });
    },
  },
};
</script>
